import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { Button, DropdownButton, MenuItem } from 'react-bootstrap'
import { Text } from '@leverege/ui-elements'

import ReactTable from 'react-table'
import AccountItem from './AccountItem'
import EditUserDialog from './EditUserDialog'
import CreateUserDialog from './CreateUserDialog'
import PaginationSearch from '../utils/PaginationSearch'
import { ProjectAccountActions, BreadcrumbActions, Constants } from '~/actions'
import { Screen, YesNoDialog, TextInput, LabelGroup } from '~/views'

import style from './style.css'

class ProjectAccountsScreen extends React.Component {

  static propTypes = {
    project : PropTypes.object
  }

  constructor( props, context ) {
    super( props, context );
    this.onEvent = this.onEvent.bind( this );

    this.pager = new PaginationSearch( this, 'projectAccounts', ( props, opts ) => {
      const { params } = this.props.match
      this.props.dispatch( ProjectAccountActions.list( params.projectId, opts ) )
    } )

    this.state = { 
      selectedId : null, 
      showDialog : false, 
      removeDevice : null, 
      start : this.pager.getStartFrom( props ), 
      search : this.pager.getSearchFrom( props )
    }
  }

  componentDidMount() {
    this.pager.loadPage( this.props )
  }

  componentWillReceiveProps( next ) {
    this.props.dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'Users' } ] ) )
    this.pager.loadIfNeeded( next )
  }

  onEvent( event, item ) {
    if ( event == 'select' ) {
      this.setState( { selectedId : item.id } );
    } else if ( event == AccountItem.REMOVE_EVENT ) {
      this.setState( { showRemoveDialog : true, removeAccount : item } )
    }
  }

  onCreate = ( user ) => {
    this.props.dispatch( ProjectAccountActions.create( this.props.match.params.projectId, user ) )
    this.setState( { showDialog : false } )
  }

  onShowEdit = ( user ) => {
    this.setState( { showEditDialog : true, edit : user } )
  }

  onEdit = ( evt ) => {
    this.props.dispatch( ProjectAccountActions.update( this.props.match.params.projectId, evt.id, evt.edits ) )
    this.setState( { showEditDialog : false, edit : null } )
  }

  onPromptRemoveYes = () => {
    const { removeAccount } = this.state
    this.props.dispatch( ProjectAccountActions.delete( this.props.match.params.projectId, removeAccount ) )
    this.setState( { showRemoveDialog : false, removeAccount : null } )
  }

  onPromptRemoveNo = () => {
    this.setState( { showRemoveDialog : false, removeAccount : null } )
  }

  options( row ) {
    return (
      <div>
        <DropdownButton pullRight
          bsStyle="link" 
          title={<i className="fa fa-gear fa-fw" />}
          id={`options-${row.original.id}`}>
          <MenuItem bsStyle="link"
            bsSize="large"
            className={style.deviceButton} 
            onClick={() => { this.onShowEdit( row.original ) }}> 
            <i className="fa fa-pencil fa-fw" />
            {' '}
            Edit 
          </MenuItem>
          <MenuItem divider />
          <MenuItem bsStyle="link"
            bsSize="large"
            className={style.deviceButton} 
            onClick={() => { this.setState( { showRemoveDialog : true, removeAccount : row.original } ) }}> 
            <i className="fa fa-times fa-fw" />
            {' '}
            Delete
          </MenuItem>
        </DropdownButton>
      </div>
    )
  }

  render() {
    const projectId = this.props.match.params.projectId
    const { projectAccounts } = this.props

    const { removeAccount, showRemoveDialog, selectedId, start, search } = this.state
    const isSelected = function( item ) { return item && item.id == selectedId; }

    const page = this.pager.getPage()
    const total = this.pager.getTotal()
    const perPage = this.pager.getPerPage()

    let items = projectAccounts.projectId == projectId ? this.pager.getPageItems() : []
    items = items.slice( )

    const columns = [ 
      { Header : 'Username', accessor : 'username' },
      { Header : 'Name', accessor : 'name' },
      { Header : 'Email', accessor : 'email' },
      { Header : 'Phone', accessor : 'phone' },
      { Header : 'User Id', accessor : 'id' },
      { Header : '',
        id : 'options',
        width : 60,
        Cell : ( row ) => {
          return this.options( row )
        } }
    ]
    const table = (
      <ReactTable
        className={classnames( '-striped -highlight', style.table, items.length == 0 && 'empty' )}
        manual
        data={items}
        columns={columns}
        loading={projectAccounts.status == Constants.STATUS_LOADING}
        showPageSizeOptions={false}
        pageSize={Math.min( projectAccounts.perPage, items.length )}
        pages={projectAccounts.total == 0 ? 0 : Math.ceil( projectAccounts.total / projectAccounts.perPage )}
        showPagination
        showPaginationBottom
        noDataText="No accounts found"
        onFetchData={( state, instance ) => {
          this.pager.onPageChange( state.page + 1 )
          // this.props.dispatch( ProjectAccountActions.list( 
          //   this.props.match.params.projectId, {start:state.pageSize * state.page } ))

        }}
        getTdProps={( state, rowInfo, column, instance ) => {
          return {
            onDoubleClick : ( e ) => { this.onShowEdit( rowInfo.original ) },
            style : {
              // background : this.isSelected( rowInfo.original ) ? 'rgba(255,200,0,0.35)' : null 
            }
          }
        }} />
    )
    
    return (
      <Screen className={style.screen}>
        <Screen.Header className={style.header}>
          <span>
            <Text variant="screenTitle" style={{ display : 'inline' }}>Users</Text>
            { total ? (
              <span className={style.count}>
                (
                {' '}
                {start}
                {' '}
                -
                {' '}
                {Math.min( total, start + perPage )}
                {' '}
                out of
                {' '}
                {total}
                {' '}
                )
              </span>
            ) : null }
          </span>
          <div style={{ display : 'inline-box', whiteSpace : 'nowrap' }}>
            <LabelGroup style={{ display : 'inline-flex', marginRight : 20 }}>
              <label><i className="fa fa-search" /></label>
              <TextInput value={search}
                hint="search" 
                changeOnBlur={false}
                changeOnReturn
                onChange={this.pager.onSearchChange} />
            </LabelGroup>
            <Button bsStyle="primary"
              className="add-button" 
              onClick={() => { this.setState( { showDialog : true } ) }}> 
              <i className="fa fa-fw fa-plus" />
              {' '}
              New User
            </Button>
          </div>
        </Screen.Header>
        <Screen.Content>
          {table}
        </Screen.Content>

        { this.state.showDialog && 
          (
            <CreateUserDialog projectId={this.props.match.params.projectId} 
              show 
              onHide={() => { this.setState( { showDialog : false } ) }} 
              onCreate={this.onCreate} />
          )}

        { this.state.showEditDialog && 
          (
            <EditUserDialog 
              projectId={this.props.match.params.projectId}
              show={this.state.showEditDialog} 
              user={this.state.edit}
              onHide={() => { this.setState( { showEditDialog : false } ) }} 
              onEdit={this.onEdit} />
          )}
        <YesNoDialog show={showRemoveDialog} 
          title={`Remove ${removeAccount && removeAccount.username}?`}
          message={<div>Are you sure you want to delete the user account?</div>}
          onYes={this.onPromptRemoveYes}
          onNo={this.onPromptRemoveNo} />
        
      </Screen>
    );
  }
} 

export default connect(
  state => ( {
    projectAccounts : state.projectAccounts
  } )
)( ProjectAccountsScreen );
